import React from 'react';
import styled from '@emotion/styled';
import clsx from 'clsx';

import { FavoriteOutline as FavoriteIcon } from 'src/components/Icons';
import { useMediaQuery } from 'src/hooks';

const PREFIX = 'AppBar-Favorites--Trigger';

const classNames = {
  root: `${PREFIX}__root`,
  icon: `${PREFIX}__icon`,
  label: `${PREFIX}__label`,
};

const TriggerRoot = styled('div')(({ theme }) => ({
  [`&.${classNames.root}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    paddingTop: 3,
    paddingBottom: 3,
    paddingRight: 6,
    paddingLeft: 6,
    borderRadius: 10,
    userSelect: 'none',
    '&:hover': {
      backgroundColor: theme.palette.background?.paper,
    },
    '& > *': {
      flexShrink: 0,
    },
  },
  [`& .${classNames.icon}`]: {
    [`&+.${classNames.label}`]: {
      marginLeft: 10,
    },
  },
}));

interface TriggerProps {
  className?: string | undefined;
  [propName: string]: any;
}

const Trigger: React.FC<TriggerProps> = ({ className, ...rest }) => {
  const isSmall = useMediaQuery('screen and (max-width: 960px)');

  return (
    <TriggerRoot className={clsx(classNames.root, className)} {...rest}>
      <FavoriteIcon className={classNames.icon} />
      {!isSmall && <span className={classNames.label}>收藏夹</span>}
    </TriggerRoot>
  );
};

export default Trigger;
